import { ThemeDefault } from '../../theming/themes';
import {
  UI_CURRENT_FUNCTIONALITY,
  UI_OPEN_TXTFLD,
  UI_SET_BRAND,
} from '../action-types/ui-types';

export const initialState = {
  selectedBrand: '',
  selectedTheme: ThemeDefault,
  availabilityFilter: false,
  currentPage: '',
  currentFunctionality: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UI_SET_BRAND:
      return {
        ...state,
        selectedTheme: { ...action.payload.theme },
        selectedBrand: action.payload.brand,
      };
    case UI_OPEN_TXTFLD:
      return {
        ...state,
        availabilityFilter: action.payload,
      };
    case UI_CURRENT_FUNCTIONALITY:
      return {
        ...state,
        currentFunctionality: action.payload,
      };
    default:
      return state;
  }
}
